import React from 'react';

/**
 * Champ « Date de fin de mandat » + nudge contextuel non bloquant.
 *
 * - Quand la date de fin est vide ET la date de début (date_mandat) est renseignée,
 *   affiche un encart info bleu pastel incitant à la remplir (KPI « Mandats à renouveler »).
 * - Propose une suggestion auto-calculée : mandat exclusif → +6 mois, sinon → +3 mois
 *   (durées standard immobilier). L'utilisateur peut l'appliquer en un clic ou saisir sa date.
 *
 * Réutilisé par le wizard de création (Step5) et la page d'édition (onglet Mandat).
 */
const addMonths = (isoDate, months) => {
  if (!isoDate) return '';
  const d = new Date(`${isoDate}T00:00:00`);
  if (Number.isNaN(d.getTime())) return '';
  d.setMonth(d.getMonth() + months);
  return d.toISOString().slice(0, 10);
};

const toFR = (iso) => (iso ? iso.split('-').reverse().join('/') : '');

const MandateEndDateField = ({
  dateFin,
  dateDebut,
  typeMandat,
  onChange,
  label = 'Date de fin de mandat',
  labelClassName = 'block text-xs font-medium text-slate-900 mb-2',
  inputClassName = 'w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500',
}) => {
  const months = typeMandat === 'exclusif' ? 6 : 3;
  const suggestion = addMonths(dateDebut, months);
  const showNudge = !dateFin && !!dateDebut;

  return (
    <div data-testid="mandate-end-field">
      <label className={labelClassName}>{label}</label>
      <input
        type="date"
        data-testid="date-fin-mandat"
        value={dateFin || ''}
        onChange={(e) => onChange(e.target.value)}
        className={inputClassName}
      />
      {showNudge && (
        <div
          className="mt-2 bg-blue-50 text-blue-700 rounded-lg px-3 py-2 text-[11px] leading-snug"
          data-testid="mandate-end-nudge"
        >
          <div className="flex items-start gap-1.5">
            <i className="bi bi-lightbulb-fill mt-0.5 shrink-0"></i>
            <div>
              <span>
                Conseil : renseignez la date de fin de mandat pour activer les alertes de
                renouvellement. Sans cette date, ce bien n'apparaîtra pas dans le KPI «&nbsp;Mandats à
                renouveler&nbsp;» du tableau de bord.
              </span>
              {suggestion && (
                <button
                  type="button"
                  onClick={() => onChange(suggestion)}
                  className="mt-1.5 block font-semibold underline hover:text-blue-900 transition-colors"
                  data-testid="mandate-end-suggest"
                >
                  <i className="bi bi-magic mr-1"></i>
                  Appliquer la suggestion ({months === 6 ? '+6 mois' : '+3 mois'}) → {toFR(suggestion)}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MandateEndDateField;
